import { type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AdminImpersonationService } from '../admin/admin-impersonation.service';
import { AuthService } from './auth.service';
import { RUNTIME_CONFIG } from '../runtime-config';

/**
 * Ajoute le jeton d'accès aux appels vers notre API.
 *
 * Le filtrage sur l'URL est essentiel : envoyer le jeton à un domaine tiers
 * équivaudrait à lui offrir les droits de l'utilisateur.
 */
export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const { apiUrl } = inject(RUNTIME_CONFIG);
  const token = inject(AuthService).accessToken();
  const impersonate = inject(AdminImpersonationService).activeProfileId();

  if (!token || !request.url.startsWith(apiUrl)) {
    return next(request);
  }

  const headers: Record<string, string> = { Authorization: `Bearer ${token}` };
  if (impersonate !== undefined) {
    headers['X-Champtable-Impersonate-Producer'] = impersonate;
  }

  return next(request.clone({ setHeaders: headers }));
};
